import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'devextreme/data/odata/store';
import { useAuth } from './../../contexts/auth';
import DataGrid, {
  Column,
  Editing,
  Paging,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  GroupPanel,
  Export,
  ColumnChooser,
  Pager,
  Scrolling,
  Summary,
  TotalItem,
  LoadPanel,
  Toolbar,
  StateStoring,
  FilterPanel,
  Selection,
} from 'devextreme-react/data-grid';
import { Item, RequiredRule } from 'devextreme-react/form';
import { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ToolbarItem as ToolbarIt } from 'devextreme-react/select-box';
import './bookings.scss';
import axios from 'axios';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/common/export/excel';
import { saveAs } from 'file-saver';
import { Button, Popup, TabPanel, TagBox, TextBox, Validator } from 'devextreme-react';
import dxDataGrid from 'devextreme/ui/data_grid';
import { useNavigate } from 'react-router-dom';
import notify from 'devextreme/ui/notify';
import { auth } from '../../firebase';
import BookingChecklist from './bookingForm/bookingChecklist/bookingChecklist';
import BookingRechnung from './bookingForm/bookingRechnung/bookingRechnung';

export default function Bookings() {
  
  const baseUrl = process.env.REACT_APP_API_URL;
  const env = process.env.REACT_APP_ENV;
  const [bookings, setBookings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [bulkPrintVisible, setBulkPrintVisible] = useState(false);
  const [bulkInvoiceVisible, setBulkInvoiceVisible] = useState(true);
  const [statuses, setStatuses] = useState<any[]>([]);
  const [invoiceStatuses, setInvoiceStatuses] = useState<any[]>([]);
  const [userData, setUserData] = useState<any>(null);
  const [cancelPopupVisible, setCancelPopupVisible] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState<any>(null);
  const [cancellationReason, setCancellationReason] = useState('');
  const [bookingsToPrint, setBookingsToPrint] = useState<any[]>([]);
  const [bookingsToInvoice, setBookingsToInvoice] = useState<any[]>([]);
  const [bookingsToEmailInvoice, setBookingsToEmailInvoice] = useState<any[]>([]);
  const [isCancellationInvoice, setIsCancellationInvoice] = useState<boolean>(false);

  const [checklistPopupVisible, setChecklistPopupVisible] = useState(false);
  const [rechnungPopupVisible, setRechnungPopupVisible] = useState(false);
  const [sendRechnungPopupVisible, setSendRechnungPopupVisible] = useState(false);
  const [toEmails, setToEmails] = useState<string[]>([]);
  const [ccEmails, setCcEmails] = useState<string[]>([]);
  const [bccEmails, setBccEmails] = useState<string[]>([]);
  const toEmailsRef = useRef<string[]>([]);
  const ccEmailsRef = useRef<string[]>([]);
  const bccEmailsRef = useRef<string[]>([]);
  const [customInvoiceItems, setCustomInvoiceItems] = useState<any[]>([]);
  const [customInvoiceAddress, setCustomInvoiceAddress] = useState<string>('');
  const [customInvoiceIsCancellation, setCustomInvoiceIsCancellation] = useState<boolean>(false);
  const [customInvoiceOldNumber, setCustomInvoiceOldNumber] = useState<string>('');
  const [customInvoiceOldDate, setCustomInvoiceOldDate] = useState<string>('');

  useEffect(() => {
    toEmailsRef.current = toEmails;
  }, [toEmails]);
  
  useEffect(() => {
    ccEmailsRef.current = ccEmails;
  }, [ccEmails]);
  
  useEffect(() => {
    bccEmailsRef.current = bccEmails;
  }, [bccEmails]);

  const navigate = useNavigate();

  const { user } = useAuth();

  const bookingDataGridRef = useRef<dxDataGrid>(null);

  useEffect(() => {
    getStatuses();
    getInvoiceStatuses();

    if(env === 'production') {
      setToEmails(['rechnungseingang@moll.de']);
      setCcEmails([]);
      setBccEmails(['mail@inn-trade.de']);
    } else {
      setToEmails(['madhan@inn-trade.de']);
      setCcEmails(['madhan@inn-trade.de']);
      setBccEmails(['madhan@inn-trade.de','madhan@inn-trade.de']);
    }
  }, []);

  useEffect(() => {
    getUserData();
    getBookingsById();
  }, [user]);

  const getBookingsById = () => {
    setLoading(true);
    const email = auth.currentUser?.email;
    axios.get(`${baseUrl}/api/Booking/bookingsByUserEmail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => {
        response.data.data.forEach((booking: any) => {
          const startDate = new Date(`${booking?.tripDate?.split("T")[0]}T${booking?.slot?.time}`);
          booking.startDate = (startDate instanceof Date && !isNaN(startDate.getTime())) ? startDate : null;
          const oneHourLater = new Date(booking.startDate);
          booking.endDate = oneHourLater.setHours(oneHourLater.getHours() + 1);
        });
        setBookings(response.data.data)
      })
      .catch(error => console.error('Error fetching bookings:', error))
      .finally(() => setLoading(false));
  };

  const getUserData = () => {
    setLoading(true);
    const email = auth.currentUser?.email;
    axios.get(`${baseUrl}/api/User/userByEmail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setUserData(response.data.data))
      .catch(error => console.error('Error fetching users:', error))
      .finally(() => setLoading(false));
  };

  const getStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/statuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const getInvoiceStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/invoiceStatuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoiceStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const isAdmin = () => ((userData && userData.role) && (userData.role.name === 'Admin'));
  const isDriver = () => ((userData && userData.role) && (userData.role.name === 'Driver'));
  const isDisponent = () => ((userData && userData.role) && (userData.role.name === 'Disponent'));
  const isCustomer = () => ((userData && userData.role) && (userData.role.name === 'Customer' || userData.role.name === 'Moll'));

  const onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Bookings');
    exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: function(options) {
            options.excelCell.font = { name: 'Arial', size: 12 };
            options.excelCell.alignment = { horizontal: 'left' };
        } 
    }).then(function() {
        workbook.xlsx.writeBuffer()
            .then(function(buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'InnKep-Bookings.xlsx');
            });
    });
  }

  const cancelBooking = async (e: any) => {
    const bookingId = e?.id;
    const statusId = statuses.find((status: any) => status.name === 'Storno')?.id;
    try {
      await axios.get(`${baseUrl}/api/Booking/updateStatus?bookingId=${bookingId}&statusId=${statusId}&reason=${cancellationReason}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then(response => {
          toast('Buchung erfolgreich storniert', 'success');
          if(response.data.data) getBookingsById();
          setTimeout(() => bookingDataGridRef.current?.repaint(), 2000);    
        });
    }
    catch(e) {
      toast('Buchung nicht erfolgreich storniert', 'error');
      console.error(e)
    }
  };

  const handleEdit = useCallback((data: any) => {
    navigate(`edit/${data.id}`); // Navigate to the edit page with the booking ID
  }, []);

  const handleDelete = useCallback((data: any) => {
    bookingDataGridRef.current?.deleteRow(bookingDataGridRef.current?.getRowIndexByKey(data.id))
  }, []);

  const handleView = useCallback((data: any) => {
    navigate(`view/${data.id}`);
  }, []);

  const handleCopy = useCallback((data: any) => { 
    navigate(`copy/${data.id}`);    
  }, []);

  const renderGridCell = (cellData: any) => {
    return (
      <div className="dx-command-cell" style={{ display: 'flex', justifyContent: 'space-around' }}>
        <Button className={'view'} stylingMode="outlined" icon="eyeopen" onClick={() => handleView(cellData.data)}/>
        <Button className={'edit'} stylingMode="outlined" icon="edit" onClick={() => handleEdit(cellData.data)}/>
        <Button className={'cancel'} stylingMode="outlined" icon="close" onClick={() => handleDelete(cellData.data)}/>
        <Button className={'copy'} stylingMode="outlined" icon="copy" onClick={() => handleCopy(cellData.data)}/>
      </div>
    );
  };

  const onSelectionChanged = (e: any) => {
    const selectedRows = e.selectedRowsData ?? [];
    if (!selectedRows || selectedRows?.length === 0) {
      setBulkPrintVisible(false);
      setBulkInvoiceVisible(true);
    } else {
      const count = selectedRows.length;
      setBulkPrintVisible(count > 0);
      const allowedStatuses = ["Abgeschlossen", "Leerfahrt", "Storno", "Ber./Stor.-Pausch."];
      const isValid =
        count >= 1 &&
        count <= 2 &&
        selectedRows.every((row: any) => {
          const isBerStorPausch = row?.status?.name === "Ber./Stor.-Pausch.";
          const kmReadingsValid = isBerStorPausch
            ? true
            : row?.pickupKmReading != null && row?.dropOffKmReading != null;

          return (
            row?.company?.id === selectedRows[0]?.company?.id &&
            row?.costCenter?.id === selectedRows[0]?.costCenter?.id &&
            kmReadingsValid &&
            (row?.invoices !== null &&
              row?.invoices[row?.invoices.length - 1]?.invoiceNumber ===
                selectedRows[0]?.invoices[selectedRows[0]?.invoices.length - 1]?.invoiceNumber) &&
            allowedStatuses.includes(row?.status?.name)
          );
        });
      setBulkInvoiceVisible(isValid);
    }
  };

  const onInitialized = useCallback((e: any) => {
    bookingDataGridRef.current = e.component;
  }, []);

  const onCellPrepared = (e: any) => {  
    if (e.column.command === "edit") {  
      e.cellElement.style.display = 'none';
    }  
    if (e.rowType === 'data' && e.column.caption === "Aktionen") {  
      // e.column.visible = false;
      //hide edit for bookings which are in status other than pending
      if(e.data?.status?.id !== 1 && isCustomer()) {
        e.cellElement.childNodes[0].childNodes[1].classList.add('hide-element');
      } 
      //hide cancel for bookings which are in status other than pending
      if(e.data?.status?.id !== 1 || isDriver()) {
        e.cellElement.childNodes[0].childNodes[2].classList.add('hide-element');
      }
    }  
    if (e.rowType === "data") {
      if (e.column?.dataField === 'status.name') {    
        switch(e.displayValue?.toLowerCase()) {
          case 'abgeschlossen':
            e.cellElement.classList.add("abgeschlossen-booking-cell");
            e.cellElement.className.replace("dx-row-alt", "");
            break;
          case 'storno':
            e.cellElement.classList.add("storno-booking-cell");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
            break;
          case 'leerfahrt':
            e.cellElement.classList.add("leerfahrt-booking-cell");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
            break;
          case 'wird durchgeführt':
            e.cellElement.classList.add("wird-durchgeführt-booking-cell", "blinking");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
            break;
          case 'stau':
            e.cellElement.classList.add("stau-booking-cell", "blinking");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
            break;
          case 'ber./stor.-pausch.':
            e.cellElement.classList.add("ber-stor-pausch-booking-cell");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
            break;
          default:
            e.cellElement.classList.add("default-booking-cell");
            e.cellElement.className = e.cellElement.className.replace("dx-row-alt", "");
        }
      }
    }
  } 

  const addButtonOptions = useMemo(() => ({
    icon: 'add',
    text: 'Buchung hinzufügen',
    onClick: () => navigate(`new`),
  }), []);
  
  const clearSelectionButtonOptions = useMemo(() => ({
    icon: 'close',
    text: 'Auswahl entfernen',
    onClick: () => bookingDataGridRef?.current?.clearSelection(),
  }), []);

  const bulkPrintButtonOptions = useMemo(
    () => ({
      icon: "print",
      text: "Übergabeprotokoll",
      onClick: () => {
        const grid = bookingDataGridRef?.current;
        if (!grid) return;
        const selectedKeys = grid.getSelectedRowKeys();
        const allRows = grid.getDataSource().items();
        const selectedData = allRows.filter((r: any) =>
          selectedKeys.includes(r.id)
        );
        const formattedData = selectedData.map((row: any) => ({
          tripDate: row?.tripDate?.split("T")[0] || "",
          slot: "",
          bookingID: row?.bookingId || "",
          vehicleInfo: ` ${row?.brand || ""} ${row?.model || ""} ${row?.color || ""} ${
            row?.vehicleType?.type || ""
          }`,
          licensePlate: row?.licensePlate || "",
          pickupAddress: `${row?.pickupLocStreet || ""} ${row?.pickupLocNo || ""}, ${
            row?.pickupLocPin || ""
          } ${row?.pickupLocCity || ""}`,
          dropOffAddress: `${row?.dropOffLocStreet || ""} ${row?.dropOffLocNo || ""}, ${
            row?.dropOffLocPin || ""
          } ${row?.dropOffLocCity || ""}`,
          pickupTime: row?.slot?.time || "",
          dropOffTime: row?.dropOffTime || "",
          notes: row?.notes || "",
        }));
        setBookingsToPrint(formattedData);
        setChecklistPopupVisible(true);
      },
    }),
    []
  );  

  const bulkInvoiceButtonOptions = useMemo(
    () => ({
      icon: "money",
      text: "Rechnung",
      onClick: async () => {
        const grid = bookingDataGridRef?.current;
        if (!grid) return;

        // Ensure invoiceStatuses is populated
        if (invoiceStatuses.length === 0) {
          await getInvoiceStatuses();
        }

        const selectedKeys = grid.getSelectedRowKeys();
        const allRows = grid.getDataSource().items();

        // const verarbeitungStatus = invoiceStatuses.find((s) => s.name === 'Verarbeitung');
        // if (!verarbeitungStatus) return;
        
        const selectedData = allRows.filter((r: any) => selectedKeys.includes(r.id));
        var isCancellation = selectedData[0]?.invoices[selectedData[0]?.invoices.length-1]?.price > 0;

        // 🔑 Resolve prices properly
        const formattedData = await Promise.all(
          selectedData.map(async (row: any) => {
            const startKm = row?.pickupKmReading;
            const endKm = row?.dropOffKmReading;
            const isBerStorPausch = row?.status?.name === "Ber./Stor.-Pausch."; 
            const isLeerfahrt = row?.status?.name === "Leerfahrt";   
            const price = isBerStorPausch ? { net: 29.95, rangeLabel: '0KM'} : await getPrice(startKm, endKm);
        
            // if (!isBerStorPausch) {
              row.priceNotExcl = price.net;
            // }
        
            return {
              bookingID: row?.bookingId || "",
              licensePlate: row?.licensePlate || "",
              // internalNotes: row?.internalNotes || "",
              internalNotes: isBerStorPausch 
                            ? `Bereitschafts- & Stornopauschale gemäß Vereinbarung – Storno < 12 h${row?.internalNotes ? ` | ${row.internalNotes}` : ""}` 
                            : isLeerfahrt
                            ? `Geplante Tour gemäß Vereinbarung – Fahrer bereits disponiert${row?.internalNotes ? ` | ${row.internalNotes}` : ""}`
                            : row?.internalNotes || "",
              costCenterName: row?.costCenter?.name || "",
              companyName: row?.company?.name || "",
              invoiceNumber: row?.invoices[row?.invoices.length - 1]?.invoiceNumber || "",
              invoiceCreatedDate: row?.invoices[row?.invoices.length - 1]?.createdDate
                ? new Date(row?.invoices[row?.invoices.length - 1]?.createdDate).toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                : new Date().toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }),
              bookingStatus: row?.status?.name || "",
              startKm,
              endKm,
              totalKm: isBerStorPausch ? 0 : endKm - startKm,
              tripDate: row?.tripDate
                ? new Date(row.tripDate).toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                : "",
              price,
              isCancellation: isCancellation,
            };
          })
        );
        setBookingsToInvoice(formattedData);
        var _isCancellation = selectedData[0]?.invoices[selectedData[0]?.invoices.length-1]?.price > 0;
        setIsCancellationInvoice(_isCancellation);
        setBookingsToEmailInvoice(selectedData);
        setRechnungPopupVisible(true);
      },
    }),
    [getInvoiceStatuses, invoiceStatuses]
  );

  const hideChecklistPopup = useCallback(() => {
    setChecklistPopupVisible(false);
  }, []);
  
  const hideInvoicePopup = useCallback(() => {
    setRechnungPopupVisible(false);
  }, []);

  const getPrice = (startKm: any, endKm: any) => {
    const response = axios.get(`${baseUrl}/api/StaticData/price?startKM=${startKm}&endKM=${endKm}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(response => response.data.data)
    .catch(error => console.error('Error fetching price:', error));
    return response;
  };

  const sendRechnungClicked = useCallback(() => {
    setSendRechnungPopupVisible(true);
  }, [sendRechnungPopupVisible]);

  const sendRechnungEmail = useCallback(() => {
    // setBooking({ ...booking, invoiceStatus: { ...invoiceStatuses.find((invoiceStatus) => invoiceStatus.name === 'Verarbeitung')}})   
    // handleBookingFormSave(null);
    // setSendRechnungConfirm(true);
    setSendRechnungPopupVisible(false);
    setRechnungPopupVisible(false);
    // (bookingsToEmailInvoice.length !== 0) ?
    //   sendRechnung(bookingsToEmailInvoice, isCancellationInvoice) :
      sendCustomRechnung(bookingsToEmailInvoice, customInvoiceAddress, customInvoiceItems, customInvoiceIsCancellation, customInvoiceOldNumber, customInvoiceOldDate);
    // sendBookingReadyEmail();
  }, [sendRechnungClicked]);

  const sendRechnung = async (bookingsToSend: any[], isCancellation: boolean) => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/Booking/sendinvoice?isCancellation=${isCancellation}`,
        {
          bookingDTOs: bookingsToSend,
          toListEmails: toEmailsRef.current,
          ccListEmails: ccEmailsRef.current,
          bccListEmails: bccEmailsRef.current,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } }
      );
  
      if (response.data.data !== null) {
        toast('Rechnung erfolgreich gesendet', 'success');
        setBookings(prev =>
          prev.map(b => {
            // Check if this booking was sent
            const sentBooking = bookingsToSend.find(sb => sb.id === b.id);
            if (!sentBooking) return b;
            return {
              ...b,
              invoices: [
                ...(b.invoices || []),
                ...response.data.data.filter((update: any) => update.bookingId === b.id),
              ],
            };
          })
        );
  
        bookingDataGridRef.current?.clearSelection();
      } else {
        toast('Rechnung nicht erfolgreich gesendet', 'error');
      }
    } catch (e) {
      toast('Rechnung nicht erfolgreich gesendet', 'error');
    }
  };

  const sendCustomRechnung = async (bookingsToSend: any[], invoiceAddress: string, invoiceItems: any[], isCancellation: boolean = false, oldInvoiceNumber: string = '', oldInvoiceDate: string = '') => {
    try {
      const response = await axios.put(
        `${baseUrl}/api/Booking/sendcustominvoice?isCancellation=${isCancellation}`,
        {
          bookingDTOs: bookingsToSend,
          address: invoiceAddress,
          customInvoiceItems: invoiceItems,
          oldInvoiceNumber: oldInvoiceNumber, 
          oldInvoiceDate: oldInvoiceDate,
          toListEmails: toEmailsRef.current,
          ccListEmails: ccEmailsRef.current,
          bccListEmails: bccEmailsRef.current,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } }
      );
  
      if (response.data.data !== null) {
        toast('Rechnung erfolgreich gesendet', 'success');
        (bookingsToSend.length !== 0) &&
        setBookings(prev =>
          prev.map(b => {
            // Check if this booking was sent
            const sentBooking = bookingsToSend.find(sb => sb.id === b.id);
            if (!sentBooking) return b;
            return {
              ...b,
              invoices: [
                ...(b.invoices || []),
                ...response.data.data.filter((update: any) => update.bookingId === b.id),
              ],
            };
          })
        );
  
        bookingDataGridRef.current?.clearSelection();
      } else {
        toast('Rechnung nicht erfolgreich gesendet', 'error');
      }
    } catch (e) {
      toast('Rechnung nicht erfolgreich gesendet', 'error');
    }
    setCustomInvoiceAddress('');
    setCustomInvoiceItems([]);
    setCustomInvoiceIsCancellation(false);
    setCustomInvoiceOldNumber('');
    setCustomInvoiceOldDate('');
  };

  const getSendRechnungButtonOptions = useMemo(() => ({
    icon: 'email',
    stylingMode: 'contained',
    type: 'default',
    text: 'Senden',
    onClick: sendRechnungEmail,
  }), [sendRechnungEmail]);

  const hideSendRechnungPopup = useCallback(() => {
    setSendRechnungPopupVisible(false);
  }, [setSendRechnungPopupVisible]);

  const getSendRechnungCloseButtonOptions = useMemo(() => ({
    text: 'Schließen',
    stylingMode: 'outlined',
    type: 'normal',
    onClick: hideSendRechnungPopup,
  }), [hideSendRechnungPopup]);

  const toast = useCallback((message: any, type: any = 'success') => {
    notify({ message: message }, type, 3000);
  }, []);

  const onBookingRemoving = (e: any) => {
    e.cancel = true; // Prevent default delete
    setRowDataToDelete(e.data);
    setCancelPopupVisible(true);
  };

  const confirmDelete = () => {
    if (!cancellationReason.trim()) return; // extra safety check
    cancelBooking(rowDataToDelete);
    setCancelPopupVisible(false);
    setCancellationReason('');
  };
  
  const cancelDelete = () => {
    setCancelPopupVisible(false);
    setCancellationReason('');
  };

  const handleReasonChange = (e: any) => {
    setCancellationReason(e.value);
  };

  return (
    <React.Fragment> 
      <Popup        
        maxHeight={'100vh'}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title={'Übergabeprotokoll'}
        visible={checklistPopupVisible}
        onHiding={hideChecklistPopup}
        className="doc-popup-content">
          <BookingChecklist bookings={bookingsToPrint} />
      </Popup>
      <Popup        
        maxHeight={'100vh'}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title={'Rechnung'}
        visible={rechnungPopupVisible}
        onHiding={hideInvoicePopup}
        className="doc-popup-content"
        toolbarItems={[
          {
            widget: 'dxButton',
            location: 'center',
            toolbar: 'top',
            options: {
              icon: 'email',
              text: 'Rechnung an den Kunden',
              stylingMode: 'contained',
              type: 'normal',
              onClick: () => sendRechnungClicked()
            }
          }
        ]}>
          <BookingRechnung bookings={bookingsToInvoice} 
                            customInvoiceItems={customInvoiceItems} 
                            onCustomInvoiceItemsChange={setCustomInvoiceItems}
                            customInvoiceAddress={customInvoiceAddress}
                            onCustomInvoiceAddressChange={setCustomInvoiceAddress}
                            customInvoiceIsCancellation={customInvoiceIsCancellation} 
                            onCustomInvoiceIsCancellationChange={setCustomInvoiceIsCancellation}
                            customInvoiceOldNumber={customInvoiceOldNumber}
                            onCustomInvoiceOldNumberChange={setCustomInvoiceOldNumber}
                            customInvoiceOldDate={customInvoiceOldDate}
                            onCustomInvoiceOldDateChange={setCustomInvoiceOldDate}
                            />
      </Popup>
      <Popup
        visible={sendRechnungPopupVisible}
        dragEnabled={false}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title="!!!Achtung!!! - Haben Sie alle Daten überprüft?"
        container=".dx-viewport"
        width={500}
        height={360}   // ⬅ increased height
      >
        <div className="dx-fieldset">
          <div className="dx-field">
            <div className="dx-field-value" style={{ width: "100%" }}>
              <TagBox
                width="100%"
                label="TO"
                labelMode="static"
                placeholder="E-Mail(s)"
                value={toEmails}
                onValueChanged={(e) => setToEmails(e.value)}
                acceptCustomValue={true}
                showSelectionControls={true}
              >
                <Validator>
                  <RequiredRule message="Bitte mindestens eine E-Mail-Adresse angeben" />
                </Validator>              
              </TagBox>
            </div>
          </div>
          <div className="dx-field">
            <div className="dx-field-value" style={{ width: "100%" }}>
              <TagBox
                label='CC'
                labelMode='static'
                placeholder="E-Mail(s)"
                value={ccEmails}
                onValueChanged={(e) => setCcEmails(e.value)}
                acceptCustomValue={true}
                showSelectionControls={true}
              />
            </div>
          </div>
          <div className="dx-field">
            <div className="dx-field-value" style={{ width: "100%" }}>
              <TagBox
                label='BCC'
                labelMode='static'
                placeholder="E-Mail(s)"
                value={bccEmails}
                onValueChanged={(e) => setBccEmails(e.value)}
                acceptCustomValue={true}
                showSelectionControls={true}
              />
            </div>
          </div>
        </div>
        <ToolbarIt
          widget="dxButton"
          toolbar="bottom"
          location="before"
          options={getSendRechnungButtonOptions}
        />
        <ToolbarIt
          widget="dxButton"
          toolbar="bottom"
          location="after"
          options={getSendRechnungCloseButtonOptions}
        />
      </Popup>
      <h2>Buchungen </h2>
      <DataGrid
        className={'dx-card content-block dx-datagrid-compact'}
        dataSource={bookings}
        keyExpr="id"
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        showBorders={true}
        columnAutoWidth={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        columnHidingEnabled={true}
        onExporting={onExporting}
        onRowRemoving={onBookingRemoving}
        onCellPrepared={onCellPrepared}
        onInitialized={onInitialized}
        onSelectionChanged={onSelectionChanged}
        repaintChangesOnly={true}>
        <LoadPanel enabled={true} showIndicator={loading}/>
        <SearchPanel visible={true} width={240} placeholder="Search..." />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={false} />
        <Export enabled={isAdmin()} />
        <ColumnChooser enabled={true} mode='select' height={'600'}/>
        <StateStoring enabled={true} type="localStorage" storageKey="innkepBookingGridState" />
        <FilterPanel visible={true} />
        <Selection mode="multiple" showCheckBoxesMode="always" />
        <Toolbar>
          <ToolbarItem location="before">
            <Button
              icon={clearSelectionButtonOptions.icon}
              text={clearSelectionButtonOptions.text}
              visible={bulkPrintVisible}
              onClick={clearSelectionButtonOptions.onClick}
            />
          </ToolbarItem> 
          <ToolbarItem location="before">
            <Button
              icon={bulkPrintButtonOptions.icon}
              text={bulkPrintButtonOptions.text}
              visible={bulkPrintVisible}
              onClick={bulkPrintButtonOptions.onClick}
            />
          </ToolbarItem> 
          <ToolbarItem location="after">
            <Button
              icon={bulkInvoiceButtonOptions.icon}
              text={bulkInvoiceButtonOptions.text}
              visible={isAdmin() && bulkInvoiceVisible}
              onClick={bulkInvoiceButtonOptions.onClick}
            />
          </ToolbarItem> 
          <ToolbarItem>
            <Button
              icon={addButtonOptions.icon}
              text={addButtonOptions.text}
              onClick={addButtonOptions.onClick}
            />
          </ToolbarItem>           
          <Item name="searchPanel" />
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50]}
          showInfo={true}
        />
        <Summary>
            <TotalItem column="bookingId" summaryType="count" />
        </Summary>
        <Editing
          refreshMode={'repaint'}
          mode="popup"
          useIcons={true}
          allowUpdating={true}
          allowDeleting={true}
          allowAdding={true}
          texts={{ confirmDeleteMessage: '' }}>
        </Editing>
        <FilterRow visible={true} />
        {/* <Scrolling mode="standard" /> */}
        <Scrolling useNative={true} showScrollbar="always" />

        {/* Basic Info */}
        <Column caption="Basisinformationen">
          <Column dataField="id" sortIndex={0} sortOrder="desc" visible={false}/>
          <Column dataField="bookingId" caption="Buchungs-ID" fixed={true} fixedPosition="sticky" allowEditing={false}
            cellRender={(cellData) => {
              const { data } = cellData; // the entire row data
              return data?.trackingLink ? (
                <a
                  href={data?.trackingLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "underline", color: "#1a5dc6" }}
                >
                  {data?.bookingId}
                </a>
              ) : (
                <span>{data?.bookingId}</span>
              );
            }} />
          <Column dataField="company.name" caption="Firma" width={100} visible={false}/>  
          <Column dataField="costCenter.name" caption="Kostenstelle" width={100} visible={false}/>
          <Column dataField="costCenterCustom" caption="Sonderkostenstelle" width={100} visible={false} />
          <Column dataField="tripDate" caption="Liefertermin" dataType="date" format="dd.MM.yyyy" allowEditing={false} />
          <Column dataField="tripWeek" caption="KW" width={80} allowEditing={false} visible={false}/>        
          <Column dataField="slot.time" caption="Lieferzeit" allowEditing={false} />
          <Column dataField="status.name" caption="Status" width={100} allowEditing={isAdmin() || isDriver()} />
        </Column>

        {/* Vehicle Information */}
        <Column caption="Fahrzeuginformationen">
          <Column dataField="brand" caption="Marke" visible={false}/>
          <Column dataField="model" caption="Modell" visible={false}/>
          <Column dataField="vehicleType.type" caption="Typ" visible={false}/>
          <Column dataField="color" caption="Farbe" visible={false}/>
          <Column dataField="licensePlate" caption="Kennzeichen/FIN">
            <RequiredRule />
          </Column>
          <Column dataField="trackingLink" caption="Tracking Link" visible={false}/>
        </Column>

        {/* Pickup Information */}
        <Column caption="Abholinformationen">
          <Column caption="Ort">
            <Column dataField="pickupLocStreet" caption="Straße" />
            <Column dataField="pickupLocNo" caption="Haus-Nr" />
            <Column dataField="pickupLocPin" caption="Postleitzahl" />
            <Column dataField="pickupLocCity" caption="Standort" />
          </Column>
          <Column caption="Kontakt">
            <Column dataField="pickupContFirstName" caption="Vorname" />
            <Column dataField="pickupContLastName" caption="Nachname" />
            <Column dataField="pickupContPhone" caption="Telefon" />
            <Column dataField="pickupContEmail" caption="Email" />
          </Column>
        </Column>

        {/* Drop-off Information */}
        <Column caption="Abgabeinformationen">
          <Column caption="Ort">
            <Column dataField="dropOffLocStreet" caption="Straße" />
            <Column dataField="dropOffLocNo" caption="Haus-Nr" />
            <Column dataField="dropOffLocPin" caption="Postleitzahl" />
            <Column dataField="dropOffLocCity" caption="Standort" />
          </Column>
          <Column caption="Kontakt">
            <Column dataField="dropOffContFirstName" caption="Vorname" />
            <Column dataField="dropOffContLastName" caption="Nachname" />
            <Column dataField="dropOffContPhone" caption="Telefon" />
            <Column dataField="dropOffContEmail" caption="Email" />
          </Column>
        </Column>

        {/* Trip Details */}
        <Column caption="Lieferinformationen" visible={false} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}>
          <Column dataField="pickUpTime" caption="Abholzeit" dataType="datetime" format="HH:mm" visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}/>
          <Column 
            dataField="totalTime" caption="Gesamtzeit" 
            visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}
            calculateCellValue={(data: any) => {
              if (data.pickUpTime && data.dropOffTime) {
                const pickUp = new Date(data.pickUpTime);
                const dropOff = new Date(data.dropOffTime);
                const diffMs = dropOff.getTime() - pickUp.getTime();
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                return `${diffHours}:${diffMinutes}`;
              }
              return null;
            }}
            allowEditing={false}
          />
          <Column dataField="dropOffTime" caption="Abgabezeit" dataType="datetime" format="HH:mm" visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}/>
          <Column dataField="pickUpCondition.name" caption="Abholzustand"  visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()} />
          <Column dataField="dropOffCondition.name" caption="Abgabezustand" visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()} />
          <Column dataField="pickupKmReading" caption="Start-KM" dataType="number" format="#,##0.00" visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}/>
          <Column 
            dataField="totalKm" caption="Gesamt-KM" 
            visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}
            calculateCellValue={(data: any) => {
              if (data.pickupKmReading != null && data.dropOffKmReading != null) {
                return data.dropOffKmReading - data.pickupKmReading;
              }
              return null;
            }}
            allowEditing={false}
          />
          <Column dataField="dropOffKmReading" caption="Ende-KM" dataType="number" format="#,##0.00" visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}/>
        </Column>

        {/* Financial Information */}
        <Column caption="Kosteninformationen" visible={false} showInColumnChooser={isAdmin()}>
          <Column 
            dataField="invoices[invoices.length-1].price" 
            caption="Preis" 
            dataType="number" 
            format="#,##0.00 €" 
            visible={isAdmin()} 
            showInColumnChooser={isAdmin()}
            calculateCellValue={(rowData) => {
              if (rowData?.invoices?.length === 0 || rowData?.invoices[rowData.invoices.length - 1]?.price == null) return null;
              return rowData.invoices[rowData.invoices.length - 1].price;
            }}
          />
          <Column 
            dataField="invoices[invoices.length-1].invoiceStatus.name" 
            caption="Rechnung Status" 
            visible={isAdmin()} 
            showInColumnChooser={isAdmin()}
            calculateCellValue={(rowData) => {
              if (rowData?.invoices?.length === 0 || !rowData?.invoices[rowData.invoices.length - 1]?.invoiceStatus?.name) return '';
              return rowData.invoices[rowData.invoices.length - 1].invoiceStatus.name;
            }}
          />
          <Column 
            dataField="invoices[invoices.length-1].invoiceNumber" 
            caption="Rechnungsnummer" 
            dataType="string" 
            visible={isAdmin()} 
            showInColumnChooser={isAdmin()}
            calculateCellValue={(rowData) => {
              if (rowData?.invoices?.length === 0 || rowData?.invoices[rowData.invoices.length - 1]?.invoiceNumber == null) return '';
              const invoices = String(rowData.invoices[rowData.invoices.length - 1].invoiceNumber)
          .split(',')
          .map(i => i.trim())
          .filter(Boolean);
              if (invoices.length === 1) return `KEP-${invoices[0]}`;
              if (invoices.length >= 2) {
          const latest = invoices[invoices.length - 1];
          const previous = invoices[invoices.length - 2];
          return `KEP-${latest} (KEP-${previous})`;
              }
              return '';
            }}
          />
        </Column>

        {/* Assignment Information */}
        <Column caption="Abtretung" visible={false}>
          <Column dataField="device.name" caption="Gerät" allowEditing={isAdmin() || isDriver() || isDisponent()} visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()} />
          <Column dataField="driver.driverId" caption="Fahrer" allowEditing={isAdmin() || isDriver() || isDisponent()}  visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()} />    
          <Column dataField="driverRemarks" caption="Fahrer Hinweis" width={200} allowEditing={isAdmin() || isDriver() || isDisponent()}/>
          <Column dataField="internalNotes" caption="Interne Notizen" allowEditing={isAdmin() || isDriver() || isDisponent()}  visible={isAdmin() || isDriver() || isDisponent()} showInColumnChooser={isAdmin() || isDriver() || isDisponent()}/>
        </Column>

        {/* User Information */}
        <Column caption="Benutzerinformationen" visible={false}>
          <Column dataField="user.email" caption="Email" allowEditing={false}/>
          <Column dataField="user.firstName" caption="Vorname" allowEditing={false}/>
          <Column dataField="user.lastName" caption="Nachname" allowEditing={false}/>
          <Column dataField="user.phoneNumber" caption="Telefon" allowEditing={false}/>
          <Column dataField="notes" caption="Benutzer Hinweis" />
        </Column>

        {/* Additional Information */}
        <Column caption="Weitere Informationen" visible={false}>
          <Column dataField="createdOn" caption="Erstellt am" dataType="datetime" format="dd.MM.yyyy HH:mm"  allowEditing={false}/>
          <Column dataField="updatedOn" caption="Update am" dataType="datetime" format="dd.MM.yyyy HH:mm"  allowEditing={false}/>
        </Column>

        {/* Command column */}
        <Column fixed={true} fixedPosition="sticky"  width={135}
            caption="Aktionen"
            alignment="center"
            cellRender={renderGridCell}
            showInColumnChooser={false}
            cssClass="no-padding-column" />
      </DataGrid>
      <Popup
        visible={cancelPopupVisible}
        onHiding={cancelDelete}
        title={`Buchung „${rowDataToDelete ? `${rowDataToDelete?.bookingId}` : ''}“ stornieren?`}
        showCloseButton={true}
        dragEnabled={false}
        height={170}
        width={500}>
        <div style={{ textAlign: 'center' }}>
          <TextBox
            placeholder="Bitte geben Sie den Stornierungsgrund ein."
            value={cancellationReason}
            onValueChanged={handleReasonChange}
            showClearButton={true}/>
          <div style={{ display: 'flex', justifyContent: 'right', gap: '10px', marginTop: '20px' }}>
            <Button
              text="Stornieren"
              onClick={confirmDelete}
              stylingMode="contained"
              disabled={!cancellationReason.trim()}/>
            <Button
              text="Abbrechen"
              onClick={cancelDelete}
              stylingMode="outlined"/>
          </div>
        </div>
      </Popup>
    </React.Fragment>
)}